import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const EventCard = ({ event }) => {
  const navigate = useNavigate();
  const [imageFailed, setImageFailed] = useState(false);
  const posterUrl = event.imageUrl?.trim();

  useEffect(() => {
    setImageFailed(false);
  }, [posterUrl]);

  const handleEventClick = () => {
    navigate(`/event/${event.id}/fights`);
  };

  return (
    <div
      className="card mb-4 shadow-sm h-100"
      style={{ cursor: "pointer" }}
      onClick={handleEventClick}
    >
      {posterUrl && !imageFailed ? (
        <img
          src={posterUrl}
          className="card-img-top"
          alt={event.name}
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div className="card-img-top event-card-poster-fallback" aria-label={`${event.name} poster unavailable`}>
          <span>UFC Event</span>
        </div>
      )}

      <div className="card-body">
        <h5 className="card-title">{event.name}</h5>
        <p className="card-text mb-1">{event.date}</p>
        <p className="card-text text-muted">{event.location}</p>
      </div>
    </div>
  );
};

export default EventCard;
